export default __webpack_public_path__ + "static/media/YouTubeOutline.64fe7c0a.svg";